class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
    this._debounceTimer = null;
  }

  connectedCallback() {
    this.scroller = this.querySelector('.t-scroller');
    if (!this.scroller) return;

    this.prevBtn = this.querySelector('.prev');
    this.nextBtn = this.querySelector('.next');
    this.currentIndex = 1; // start at second card
    this._debounceTimer = null;

    this.updateSlidesList();

    // arrow handlers
    this._prevHandler = () => this.scroll(-1);
    this._nextHandler = () => this.scroll(1);
    this.prevBtn?.addEventListener('click', this._prevHandler);
    this.nextBtn?.addEventListener('click', this._nextHandler);

    window.addEventListener('resize', () => this.recenter());

    this.waitForImages().then(() => {
      requestAnimationFrame(() => {
        this.scrollToIndex(this.currentIndex, false); // second card is centered initially
      });
    });

  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this._prevHandler);
    this.nextBtn?.removeEventListener('click', this._nextHandler);
  }

  updateSlidesList() {
    this.slides = Array.from(this.querySelectorAll('.t-slide'));
  }

  waitForImages() {
    const imgs = Array.from(this.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();
    return Promise.all(
      imgs.map(img => img.complete ? Promise.resolve() :
        new Promise(res => img.addEventListener('load', res, { once: true }))
      )
    );
  }

  slideMetrics() {
    const first = this.slides[0];
    const rect = first.getBoundingClientRect();
    const style = getComputedStyle(this.scroller);
    const gap = parseFloat(style.gap || style.columnGap) || 0;
    return { width: rect.width, step: rect.width + gap };
  }

  scroll(dir) {
    this.updateSlidesList();
    if (!this.slides.length) return;

    let targetIndex = this.currentIndex + dir;

    // clamp to valid range
    targetIndex = Math.max(0, Math.min(targetIndex, this.slides.length - 1));

    const centeredIndex = this.getCenteredIndex();
    const isVisibleButNotActive = targetIndex === centeredIndex && !this.slides[targetIndex].classList.contains('active');

    if (isVisibleButNotActive) {
      // Step 1: just highlight
      this.highlightActive(targetIndex);
      this.currentIndex = targetIndex; // update index for next click
    } else {
      // Step 2: scroll normally
      this.currentIndex = targetIndex;
      this.scrollToIndex(targetIndex, true);
    }
  }





  scrollToIndex(index, smooth = true) {
    this.updateSlidesList();
    if (!this.slides.length) return;

    const { width } = this.slideMetrics();
    const slide = this.slides[index];
    const slideLeft = slide.offsetLeft;

    const scrollLeft = slideLeft - (this.scroller.clientWidth - width) / 2;

    this.scroller.scrollTo({
      left: scrollLeft,
      behavior: smooth ? 'smooth' : 'auto'
    });

    this.highlightActive(index);
  }


  getCenteredIndex() {
    const scrollerRect = this.scroller.getBoundingClientRect();
    const center = scrollerRect.left + scrollerRect.width / 2;

    let closest = 0, minDist = Infinity;
    this.slides.forEach((slide, i) => {
      const rect = slide.getBoundingClientRect();
      const slideCenter = rect.left + rect.width / 2;
      const dist = Math.abs(slideCenter - center);
      if (dist < minDist) {
        minDist = dist;
        closest = i;
      }
    });
    return closest;
  }

  highlightActive(index) {
    this.slides.forEach(s => s.classList.remove('active'));
    if (this.slides[index]) {
      this.slides[index].classList.add('active');
    }
  }

  recenter() {
    this.scrollToIndex(this.currentIndex, false);
  }
}

if (!customElements.get('testimonial-slider')) {
  customElements.define('testimonial-slider', TestimonialSlider);
}





